import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  filterActions,
  filterSelectors
} from '../../../store/modules/filter';

export const useSearch = () => {
  const dispatch = useDispatch();
  const filters = useSelector(filterSelectors.selectTemplatesFilters);
  const [text, setText] = useState('');

  const { name } = filters;

  useEffect(() => {
    if (name === undefined) return;
    setText(name);
  }, [name]);

  const updateSearchName = useCallback(
    () => {
      dispatch(filterActions.updateSearchName(text));
      dispatch(filterActions.updateSavedFilters({ name: text }));
    },
    [text]
  );

  const handleChange = useCallback(
    (event: { target: HTMLInputElement }) =>
      setText(event.target.value.toLowerCase().trimLeft()),
    []
  );

  return [text, setText, handleChange, updateSearchName] as const;
};
